import { useState, type FC } from "react";
import { Heading1 } from "@/components/podkit/typography/Headings";
import { Text } from "@/components/podkit/typography/Text";
import { IconPlus } from "@/assets/icons/geist/IconPlus";
import { Button } from "@/components/flexkit/Button";
import { CreateWorkflowDialog } from "@/components/automations/CreateAutomationDialog";
import { WorkflowList } from "@/components/automations/AutomationList";
import { AutomationsEducationPage } from "@/routes/automations/AutomationsEducationPage";
import { LoadingState } from "@/components/podkit/loading/LoadingState";
import { useFlagWorkflowsEnabled, WorkflowAccessLevel } from "@/hooks/use-flag";

export const AutomationsPage: FC = () => {
    const { accessLevel: workflowAccessLevel, loading: isLoadingFlag } = useFlagWorkflowsEnabled();

    if (isLoadingFlag) {
        return <LoadingState />;
    }

    switch (workflowAccessLevel) {
        case WorkflowAccessLevel.Full:
            return <AutomationsPageContent />;
        case WorkflowAccessLevel.Teaser:
            return <AutomationsEducationPage />;
        case WorkflowAccessLevel.None:
        default:
            return null;
    }
};

const AutomationsPageContent: FC = () => {
    const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

    const handleCreateWorkflow = () => {
        setIsCreateDialogOpen(true);
    };

    return (
        <div data-testid="workflows-page" className="flex flex-col gap-6">
            <div className="flex items-start justify-between">
                <div className="flex flex-col">
                    <Heading1>Automations</Heading1>
                    <Text className="text-base text-content-strong">
                        Run parallel automations across projects with Ona to automate, track, and report at scale.
                    </Text>
                </div>
                <Button
                    LeadingIcon={IconPlus}
                    variant="primary"
                    onClick={handleCreateWorkflow}
                    data-testid="new-workflow-dialog-workflows-page"
                    data-tracking-id="show-new-automation-dialog-automations-page"
                >
                    New Automation
                </Button>
            </div>
            <WorkflowList onCreateWorkflow={handleCreateWorkflow} />
            <CreateWorkflowDialog open={isCreateDialogOpen} onClose={() => setIsCreateDialogOpen(false)} />
        </div>
    );
};
